import { IImage } from '@/api/interfaces/IImage'
import { AuthUser } from '@/store/auth'

export type IBaseUserUnion = {
  hash: string
  username: string
  profileImage: IImage | null
}

export const authUserImage = (user?: AuthUser): IBaseUserUnion | undefined => {
  if (!user) {
    return undefined
  }
  return {
    hash: user.hash,
    username: user.username,
    profileImage: user.profileThumbnail
      ? ({ thumbnail: user.profileThumbnail } as IImage)
      : null,
  }
}
